interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <nav className="mt-8 flex items-center justify-center gap-1.5 flex-wrap" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="h-9 px-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line align-middle"></i>
        上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          aria-current={p === current ? 'page' : undefined}
          className={`w-9 h-9 rounded-md text-sm font-medium transition-colors cursor-pointer ${
            p === current
              ? 'bg-primary-500 text-primary-50'
              : 'border border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600'
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="h-9 px-3 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-700 hover:border-primary-300 hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line align-middle"></i>
      </button>
    </nav>
  );
}